import * as React from 'react';
import classNames from 'classnames';
import {PriorityIcon, Icon} from '@priority-software/priority-style-react';
import {isPopup} from '../../../_shared/GWTBridge/invoke/netForm';
import styles from '../styles/FieldSearch.module.scss';

const borderWidth = 1;

function generateStyle(element, isRTL, windowRelative) {
    const inputWidth = element.right - element.left;
    const iconSide = element.bottom - element.top;
    let leftPosition;
    let rightPosition;
    if (windowRelative) {
        leftPosition = isRTL
            ? element.left + borderWidth
            : element.left + inputWidth - iconSide - borderWidth;
    } else {
        leftPosition = isRTL && borderWidth;
        rightPosition = !isRTL && borderWidth;
    }

    return {
        height: windowRelative ? iconSide : '100%',
        width: iconSide,
        left: leftPosition ? leftPosition : 'auto',
        right: rightPosition ? rightPosition : 'auto',
        top: windowRelative ? element.top + borderWidth : borderWidth
    };
}

interface HoveringArrowButtonProps {
    elementRect: DOMRect | ClientRect;
    windowRelative: boolean;
    isOpen: boolean;

    onArrowClick(event: any): void;

    onClearClick(event: any): void;

    isRtl: boolean;
    searchQuery: string;
}

export const HoveringArrowButton = (props: HoveringArrowButtonProps) => {
    const {elementRect, isOpen, searchQuery, onArrowClick, onClearClick, windowRelative, isRtl} =
        props;
    const iconStyle = generateStyle(elementRect, isRtl, windowRelative);
    const elementHeight = elementRect.bottom - elementRect.top;
    const style = {width: elementHeight, ...iconStyle};
    const classes = classNames(
        'ignore-react-onclickoutside',
        styles.inputIcon,
        styles.fieldBtn,
        isPopup() ? styles.popupDropdownStyle : styles.regularIcon
    );
    const iconProps =
        searchQuery && isOpen
            ? {
                  icon: PriorityIcon.closeSmall,
                  onClick: onClearClick
              }
            : {
                  icon: PriorityIcon.arrowDropDown,
                  onClick: onArrowClick
              };
    return <Icon skin="standart" componentClasses={classes} style={style} {...iconProps} />;
};
